import { floatNumValidator, isNumValidator } from 'Modules'

export const nonDigits = /\D/g
export const floatNum = /^[0-9]*[.]?[0-9]+$/

export const emailRegExp =
	// eslint-disable-next-line
	/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const domainRegExp =
	// eslint-disable-next-line
	/^((http|https):\/\/)?[a-zа-яёЁ0-9]+([\-\.]{1}[a-zа-яёЁ0-9]+)*\.[a-zа-яёЁ]{2,5}(:[0-9]{1,5})?(\/.*)?/

export const latinChars = /[A-z]/

export const cyrillicChars = /[а-яёА-ЯЁ]/

export const cyrillicCharsWithSymbols = /^[а-яёА-ЯЁ][^a-zA-Z]*$/

export const startsWithAlphanumericCyrillic = /^[а-яА-ЯёЁ0-9][а-яА-ЯёЁ0-9\s\W]*$/i

export const onlyCyrillicCharsWithHyphen = /[^а-яё\s-]/i

export const posNameAllowedSymbols = /[^А-яёЁA-z0-9()\-*&_., ]/

export const validateNumber = (value: string) => isNumValidator(value)
export const validateFloatNumber = (value: string) => floatNumValidator(value)
export const ipAdressRegExp =
	/^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/

export const passportSeriesRegExp = /^[0-9]{4}$/

export const passportNumberRegExp = /^[0-9]{6}$/

export const okvedRegExp =
	/^\d\d(?:([.])\d(?:\d(?:\1\d\d?|)|)|)(?:, \d\d(?:([.,])\d(?:\d(?:\2\d\d?|)|)|))*$/

export const passportCodeRegExp = /^[0-9]{6}$/

export const urlWithHttpRegExp =
	// eslint-disable-next-line
	/^https?:\/\/(?:www\.)?[-a-zA-Zёа-я0-9@:%._\+~#=]{1,256}\.[a-zA-Zёа-я0-9()]{1,6}\b(?:[-a-zA-Zёа-я0-9()@:%_\+.~#?&\/=]*)$/

export const isNumInStr = /\d/
export const isStrUpperCase = /[A-Z]/g
export const isStrLowerCase = /[a-z]/g

export const house_reg = /(д\s)/g
export const apartment_reg = /(кв\s)/g
export const numberLatinicCyrillic = /[^А-яёЁA-z0-9]/
